<template>
  <div>
    <nx-search
      ref="searchForm"
      :source="searchForm"
      :config="searchConfig"
      @hiddenChange="hiddenChange"
    >
      <div slot="search">
        <el-button type="primary" @click="reset()">查询</el-button>
        <el-button @click="reset(1)">重置</el-button>
      </div>
    </nx-search>
    <nx-table
      ref="nxTable"
      table-title="终端型号备案列表"
      :data="tableData"
      @search="search"
    >
      <template slot="operation">
        <el-button v-perm="'/notRoadFour/terminalModel/add'" type="primary" icon="el-icon-plus" @click="toggleDialog({recordResult: '', status: true,type: 'add'})">新增</el-button>
      </template>
      <el-table-column label="终端型号" prop="tboxModel" width="170"></el-table-column>
      <el-table-column label="生产企业名称" prop="tboxFactoryName" width="200"></el-table-column>
      <el-table-column label="生产企业机构代码" prop="tboxFactoryId" width="180"></el-table-column>
      <el-table-column label="备案时间" prop="recordTime" width="170">
        <template slot-scope="{row}">
          {{ $utils.formatDate(row.recordTime) || '/' }}
        </template>
      </el-table-column>
      <el-table-column label="备案状态" prop="recordResult" width="130">
        <template slot-scope="{row}">
          <el-tooltip placement="top" effect="light" :disabled="row.recordResult!==4 ">
            <div slot="content">{{ row.recordMessage ? row.recordMessage: '备案失败'}}</div>
            <span
            :class="{1: 'nx-text-warning', 2: 'nx-text-warning', 3: 'nx-text-success', 4: 'nx-text-danger'}[row.recordResult]"
          >
            {{ (recordResultTypes.find((item) => item.value === row.recordResult) || {}).label || '' }}
          </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="授权状态" prop="permitResult" width="130">
        <template slot-scope="{row}">
          <el-tooltip placement="top" effect="light" :disabled="row.permitResult!==4 ">
            <div slot="content">{{ row.permitMessage ? row.permitMessage: '备案失败'}}</div>
              <span
            :class="{1: 'nx-text-warning', 2: 'nx-text-warning', 3: 'nx-text-success', 4: 'nx-text-danger'}[row.permitResult]"
          >
            {{
              {
                1: '审核中',
                2: '未备案',
                3: '备案成功',
                4: '备案失败'
              }[row.permitResult]
            }}
          </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createName" min-width="140"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="170">
        <template slot-scope="{row}">
          {{ $utils.formatDate(row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="修改人" prop="updateName" width="140"></el-table-column>
      <el-table-column label="修改时间" prop="updateTime" width="170">
        <template slot-scope="{row}">
          {{ $utils.formatDate(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="" fixed="right" width="200">
        <template slot-scope="{row}">
          <el-button
            v-if="[2, 4].includes(row.recordResult) || (row.recordResult===3 && [2, 4].includes(row.permitResult))"
            v-perm="'/notRoadFour/terminalModel/update'"
            type="text"
            @click="toggleDialog({recordResult: row.permitResult, status: true, id: row.id, type:'edit'})"
          >编辑</el-button>
          <el-button
            v-if="[2, 4].includes(row.recordResult) || (row.recordResult === 3 && [2, 4].includes(row.permitResult))"
            v-perm="'/notRoadFour/terminalModel/filing'"
            type="text"
            @click="terminalModelRecord(row.id)"
          >备案</el-button>
          <el-button
            v-if="[2, 4].includes(row.recordResult) || (row.recordResult === 3 && [2, 4].includes(row.permitResult))"
            v-perm="'/notRoadFour/terminalModel/filingResults'"
            type="text"
            @click="getRecordResult(row.id)"
          >备案结果查询</el-button>
          <el-button
            type="text"
            @click="toggleDialog({recordResult: '',status: true, id: row.id, type: 'detail'})"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </nx-table>
    <submit-dialog
      :id="dialogConfig.id"
      :type="dialogConfig.type"
      :recordResult="dialogConfig.recordResult"
      :visible.sync="dialogConfig.status"
      @onConfirm="$refs.nxTable.search(1)"
    ></submit-dialog>
  </div>
</template>
<script>
import { getTerminalList, recordTerminalModel, getRecordResult } from '@/api/notRoadFour/terminalModel.js';
import SubmitDialog from './components/submitDialog.vue';
import { recordResultTypes } from '../config/types.js';

export default {
  name: 'TerminalModel',
  components: {
    SubmitDialog
  },
  props: {
  },
  data() {
    return {
      searchForm: {
        tboxModel: '', // 终端型号
        tboxFactoryName: '', // 厂商名称
        recordTimeSection: [], // 备案时间
        recordResult: '' // 备案状态
      },
      recordResultTypes,
      tableData: [],
      dialogConfig: {
        status: false,
        id: ''
      }
    };
  },
  computed: {
    searchConfig() {
      return [
        {
          key: 'tboxModel',
          component: 'el-input',
          label: '终端型号:',
          span: 8,
          props: {
            placeholder: '请输入终端型号',
            clearable: true,
            maxlength: 30
          }
        },
        {
          key: 'tboxFactoryName',
          component: 'el-input',
          label: '生产企业名称:',
          span: 8,
          props: {
            placeholder: '请输入生产企业名称',
            clearable: true,
            maxlength: 30
          }
        },
        {
          key: 'recordTimeSection',
          component: 'el-date-picker',
          label: '备案时间:',
          span: 8,
          props: {
            clearable: true,
            valueFormat: 'timestamp',
            type: 'datetimerange',
            defaultTime: ['00:00:00', '23:59:59'],
            rangeSeparator: '-',
            startPlaceholder: '请选择开始时间',
            endPlaceholder: '请选择结束时间'
          }
        },
        {
          key: 'recordResult',
          component: 'el-select',
          label: '备案状态:',
          span: 8,
          props: {
            clearable: true,
            placeholder: '请选择备案状态'
          },
          data: [
            { label: '全部', value: '' },
            ...this.recordResultTypes
          ]
        },
        {
          component: 'slot',
          slotName: 'search',
          span: 16
        }
      ];
    }
  },
  watch: {
  },
  created() {

  },
  mounted() {
  },
  methods: {
    // 收起筛选条件时重新计算table高度
    hiddenChange() {
      this.$refs.nxTable.getTableHeight();
    },
    // 搜索
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      const { recordTimeSection } = this.searchForm;
      const params = {
        ...this.searchForm,
        pageNum,
        pageSize,
        startTime: recordTimeSection ? recordTimeSection[0] : '',
        endTime: recordTimeSection ? recordTimeSection[1] : ''
      };
      delete params.recordTimeSection;
      const { data } = await getTerminalList(params);
      this.tableData = data.list;
      pagination.total = data.total;
    },
    // 查询
    reset(type) {
      if (type) {
        this.$refs.searchForm.resetFields();
      }
      this.$refs.nxTable.search(1);
    },
    toggleDialog({ recordResult = '', status = false, id = '', type }) {
      this.dialogConfig = {
        status,
        id,
        type,
        recordResult
      };
    },
    async terminalModelRecord(id) {
      const confirm = await this.$confirm('即将对终端型号备案，备案成功后不可修改，确认继续操作吗？', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      if (confirm !== 'confirm') return;
      await recordTerminalModel(id);
      this.$message.success('操作成功');
      this.$refs.nxTable.search();
    },
    // 终端备案结果查询
    async getRecordResult(id) {
      await getRecordResult(id);
      this.$refs.nxTable.search();
    }
  }
};
</script>
<style scoped lang="scss">
</style>
